import React from "react";
import PropTypes from "prop-types";
import "./Card.scss";

const Card = ({ children, small = false, header = "", className = "" }) => (
  <div className={`Card ${small ? "" : "large"} ${className}`}>
    {header && <div className="Card-header">{header}</div>}
    <div className="Card-content">{children}</div>
  </div>
);

Card.propTypes = {
  children: PropTypes.node.isRequired,
  small: PropTypes.bool,
  header: PropTypes.string,
  className: PropTypes.string,
};

export default Card;
